import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, formatQueryParams } from '../../utils';
import type { MapperItemConfig } from './types';

export const getContentPagePath = ({ slug = '', source }: MapperItemConfig) => {
    const params = { article_id: slug };
    return pathfinder(PATHFINDER.CONTENT_PAGE, params, formatQueryParams({ source }));
};
